// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F6vD","clinicsSelect":"styles_clinicsSelect__3flev"};